module.exports = __webpack_public_path__ + "static/media/ussf90mintext-medium.7ecfea40.woff2";